import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { uiNeutrals } from "../../../../constants/uiNeutrals";

const DealListLoadMoreButton = ({ onClick, disabled = false, loading = false }) => {
  const theme = useTheme();
  const n = theme.palette.neutral || uiNeutrals;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        mt: 2,
        mb: 2,
      }}
    >
      <Button
        type="button"
        variant="text"
        disableElevation
        onClick={onClick}
        disabled={disabled || loading}
        sx={{
          borderRadius: 999,
          px: 1,
          py: 1.5,
          minWidth: 120,
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.85rem",
          color: "#2d2d2d",
          bgcolor: n.surface,
          boxShadow: "none",
          lineHeight: 1.2,
          "&:hover": {
            bgcolor: n.surfaceHover,
            boxShadow: "none",
          },
          "&.Mui-disabled": {
            bgcolor: n.surface,
            color: "#9a9a9a",
          },
        }}
      >
        {loading ? "Loading…" : "Load more"}
      </Button>
    </Box>
  );
};

export default DealListLoadMoreButton;
